import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SnakeService {

  openSnakeEvent: any = new Subject();
  openSnakeDangerEvent: any = new Subject();

  constructor() {
  }

  showSnake(message: string): void {
    this.openSnakeEvent.next(message);
  }

  showDangerSnake(message: string): void {
    this.openSnakeDangerEvent.next(message);
  }


}
